import TambahTransferPrelim from './TambahTransferPrelim';

export default TambahTransferPrelim;
